<template>
  <header class="wrapper">
    <div
      class="header container"
      :class="{ 'header_search-expanded': isSearchExpanded }"
    >
      <v-logo class="header__logo" :to="homeLink" />

      <theme-switch class="header__theme-switch" />

      <device class="header__device" />
    </div>
    <navigation />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import VLogo from '@/components/VLogo';
import Device from './Device';
import Navigation from './Navigation';
import ThemeSwitch from './ThemeSwitch.vue';

export default {
  components: {
    Device, Navigation, ThemeSwitch, VLogo,
  },
  computed: {
    ...mapGetters(['currentDeviceOS']),
    isSearchExpanded() {
      return this.$store.getters.isSearchExpanded;
    },
    homeLink() {
      if (!this.currentDeviceOS) {
        return '/';
      }

      return `/?compatibility=${this.currentDeviceOS}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.wrapper {
  position: relative;
}

.header {
  padding: 25px 0;
  display: flex;
  align-items: center;

  @include notebook {
    padding: 10px 0;
  }

  &_search-expanded {
    @include notebook {
      .header__search {
        margin-left: 10px;
      }

      .header__device,
      .header__theme-switch {
        display: none;
      }
    }
  }

  &__logo {
    @include notebook {
      order: 1;
    }
  }

  &__search {
    margin: 0 15px 0 20px;

    @include notebook {
      order: 4;
      margin-left: auto;
      margin-right: 6px;
    }
  }

  &__theme-switch {
    margin-left: auto;
    margin-right: 20px;

    @include notebook {
      order: 3;
      margin-right: 15px;
    }
  }

  &__device {
    @include notebook {
      order: 2;
      margin-left: 14px;
      margin-right: 14px;
      display: block;
      min-width: 0;
      position: relative;
      height: 41px;
    }
  }
}
</style>
